import React from 'react';
import logo from '../logo.svg';
import '../styles/bundle.css';
import Header from './header.js';
import QuoteForm from './quoteform.js';
import Footer from './footer.js';

function App() {
  return (
    <div>
      {/* <Header></Header> */}
      <QuoteForm></QuoteForm>
      <Footer></Footer>
    </div>
  );
}

export default App;
